import { appContent } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-shrink-0 w-48 md:w-56">
            <img
              src={appContent.image}
              alt="黑料网APP界面预览"
              className="w-full h-auto rounded-2xl shadow-lg"
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-100 rounded-full mb-3">移动端入口</span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{appContent.title}</h2>
            <p className="mt-3 text-sm text-foreground-700 leading-relaxed max-w-lg">{appContent.desc}</p>
            <div className="mt-5 grid grid-cols-2 gap-3">
              {appContent.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center rounded-md bg-primary-100 flex-shrink-0">
                    <i className="ri-check-line text-primary-500 text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-700">{f}</span>
                </div>
              ))}
            </div>
            <div className="mt-6 flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-background-50 border border-background-300 text-foreground-800 font-medium text-sm rounded-lg hover:border-foreground-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 内测版
              </a>
              <a
                href="#"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-background-50 border border-background-300 text-foreground-800 font-medium text-sm rounded-lg hover:border-foreground-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 内测版
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}